import React from 'react'

import { MapScreen } from '../../components/MapScreen/MapScreen'


/* eslint react/prop-types: ["off"] */
export function Map08() {
    return (
        <MapScreen part="08" />
    )
}
